__turbopack_context__.v({
  "active": "pdTPha_active",
  "button-wrapper": "pdTPha_button-wrapper",
  "collapse-membership": "pdTPha_collapse-membership",
  "collapse-membership-item": "pdTPha_collapse-membership-item",
  "content-desc": "pdTPha_content-desc",
  "panel-title": "pdTPha_panel-title",
});
